import { put, call, select } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as TypesInformation } from '../../getProcedureInformation/actions';
import ChangePhotoRequestRepository from '../../../../repositories/ChangePhotoRequestRepository';
import ChangePhotoRequestDataRepository from '../../../../../data/repositories/ChangePhotoRequestDataRepository';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.REGISTER_UPDATE_PHOTO_REQUEST });
    const changePhotoRequestRepository: ChangePhotoRequestRepository =
      new ChangePhotoRequestDataRepository();
    // const id = yield select((state: any) => state.profile?.period?.id);
    const currentPeriod = yield select((state: any) =>
      String(state.profile?.data?.academic?.period?.id)
    );
    const changePhotoRegisterResponse = yield call(
      changePhotoRequestRepository.register,
      currentPeriod,
      action.imgBase64,
      action.fileType,
      action.procedureId
    );

    if (!changePhotoRegisterResponse) {
      yield put({
        type: Types.REGISTER_UPDATE_PHOTO_FAILURE,
        error: 'No se pudo registrar'
      });
      return;
    }

    if (changePhotoRegisterResponse?.error) {
      yield put({
        type: Types.REGISTER_UPDATE_PHOTO_FAILURE,
        requestId: changePhotoRegisterResponse?.requestId,
        error:
          changePhotoRegisterResponse?.error ||
          'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
      });
      return;
    }

    yield put({
      type: TypesInformation.GET_PROCEDURE_INFORMATION_CLEAR
    });
    yield put({
      type: Types.REGISTER_UPDATE_PHOTO_SUCCESS,
      requestId: changePhotoRegisterResponse?.requestId
    });
  } catch (error) {
    yield put({
      type: Types.REGISTER_UPDATE_PHOTO_FAILURE,
      error:
        'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
    });
  }
}
